import { ResponseService } from './../services/response.service';
import { PhoneService } from './../services/phone.service';
import { Profile } from './../models/profile';
import { LocalStorageService } from './../services/local-storage.service';
import { CompanyService } from './../services/company.service';
import { CustomValidators } from 'ng2-validation';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { ApiService } from './../services/api.service';
import { NotificationsService } from 'angular2-notifications';
import { User } from './../interfaces/user.model';
import { UserService } from './../services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CustomDSValidators } from './../shared/validators/custom-validators';

@Component({
  selector: 'app-edit-user-profile',
  templateUrl: './edit-user-profile.component.html',
})
export class EditUserProfileComponent implements OnInit {

  private phoneCodes;

  private profile: Profile;

  private loading: Boolean = false;

  private profileForm: FormGroup;
  public profileLoading: Boolean = true;

  constructor(
    private userService: UserService,
    private notificationsService: NotificationsService,
    private apiService: ApiService,
    private breadcrumbService: BreadcrumbService,
    private phoneService: PhoneService,
    private localStorageService: LocalStorageService,
    private responseService: ResponseService
  ) {

    let cc_phone =  new FormControl('');
    let phone = new FormControl('', [Validators.required, CustomDSValidators.internationalPhoneNumber(cc_phone)]);

    this.profileForm = new FormGroup({
      email: new FormControl('', [CustomValidators.email]),
      info: new FormGroup({
        first_name: new FormControl(''),
        last_name: new FormControl(''),
        cc_phone: cc_phone,
        phone: phone,
        city: new FormControl(''),
        country: new FormControl(''),
        house_number: new FormControl(''),
        local_number: new FormControl(''),
        street: new FormControl(''),
        postal_code: new FormControl('', [CustomDSValidators.polishPostalCode])
      })
    });
  }

  ngOnInit() {
    this.phoneCodes = this.phoneService.getCountryCodes();

    this.userService.getUser()
      .subscribe(
      (profile: Profile) => {
        this.profile = profile;
        this.profileForm.setValue({
          email: this.profile.email,
          info: {
            first_name: this.profile.info.first_name === null ? '' : this.profile.info.first_name,
            last_name: this.profile.info.last_name === null ? '' : this.profile.info.last_name,
            cc_phone: this.profile.info.cc_phone === null ? 'PL' : this.profile.info.cc_phone,
            phone: this.profile.info.phone === null ? '' : this.profile.info.phone,
            city: this.profile.info.city === null ? '' : this.profile.info.city,
            country: this.profile.info.country === null ? 518 : this.profile.info.country,
            house_number: this.profile.info.house_number === null ? '' : this.profile.info.house_number,
            local_number: this.profile.info.local_number === null ? '' : this.profile.info.local_number,
            street: this.profile.info.street === null ? '' : this.profile.info.street,
            postal_code: this.profile.info.postal_code === null ? '' : this.profile.info.postal_code,
          }
        });

        this.profileLoading = false;
      }
    );

    this.breadcrumbService.addFriendlyNameForRoute('/profile', 'Profil');
    this.breadcrumbService.addFriendlyNameForRoute('/profile/edit', 'Edycja profilu');
  }

  updateProfile() {
    this.loading = true;
    this.apiService.put(`/profile`, this.profileForm.controls['info'].value).subscribe(
      (response) => {
        this.responseService.success(true, response, false, 'edit');
        this.userService.getUser(true);
        this.loading = false;

      },
      (error) => {
        this.responseService.error(error, this.profileForm);
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/user-profile/edit-user-profile.component.ts